export default __webpack_public_path__ + "static/media/blue.6d94c809.mp4";